import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class AppServiceService {

  private defaultTitle = 'UC Davis Directory';
  private titleSubject: BehaviorSubject<String> = new BehaviorSubject<String>('UC Davis Directory');
  public title: Observable<String>;

  public searchString: Observable<String>;
  private searchStringSubject: BehaviorSubject<String> = new BehaviorSubject<String>('');
  
  constructor(private titleService: Title) {
	
	this.title = this.titleSubject.asObservable();
  this.searchString = this.searchStringSubject.asObservable();
 }
  
  setTitle(title: String) {
	this.titleSubject.next(title);
  }
  
  getTitle(): Observable<String> {
	return this.titleSubject;
  }

  setSearchString(searchString: String) {
    this.searchStringSubject.next(searchString);
    }
    
    getSearchString(): Observable<String> {
    return this.searchString;
    }
  
}
